export default __webpack_public_path__ + "static/media/day.c5cf49fb.svg";